/**
 * Role Constants - Single Source of Truth
 * 
 * Bu dosya shared/constants/ altında tutulur ve sync-shared.js ile
 * hem backend hem frontend'e kopyalanır.
 * 
 * USAGE (Backend):
 * const { ROLES, EDIT_ROLES, ALL_ROLES } = require('../shared/constants/roles');
 * 
 * USAGE (Frontend):
 * import { ROLES, EDIT_ROLES } from '../shared/constants/roles';
 */

export const ROLES = {
    ADMIN: 'admin',
    OPERASYON: 'operasyon',
    GORUNTULEME: 'goruntuleme',
    MUHASEBE: 'muhasebe',
    PAZARLAMA: 'pazarlama',
    TEKNIK: 'teknik'
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];

// Roles that can create/edit/delete content
// Rota 3.39: pazarlama bu gruptan ÇIKTI. 2026-03-16'da "şimdilik operasyonla aynı"
// diye eklenmişti ve siparişi, ödeme kaydını, ürünü düzenleyebiliyordu; menü ise
// ona yalnız müşterileri gösteriyordu. Pazarlama artık müşteri ilişkileri rolü:
// müşteri yazma yetkisi aşağıdaki ayrı gruptan gelir. Bu gruba ekleme yapmadan
// önce grubu kullanan her ucun o role açılacağını hesaba kat.
export const EDIT_ROLES: string[] = [ROLES.ADMIN, ROLES.OPERASYON];

// Müşteri kaydı yazan roller: oluşturma, düzenleme, adres, görüşme, etiket atama.
// Birleştirme, eşleştirme, siparişe bilgi yansıtma ve etiket TANIMI bu grupta
// DEĞİL — onlar `EDIT_ROLES`te kalır (birleştirme siparişleri taşır). Müşterinin
// vade/indirim koşulunu belirleyen alanlar da bu grupla değil `EDIT_ROLES` ile
// değişir; kilit `customerService` içinde (rota 3.39).
export const CUSTOMER_EDIT_ROLES: string[] = [ROLES.ADMIN, ROLES.OPERASYON, ROLES.PAZARLAMA];

// Müşteri takibini (sonraki adım hatırlatması) gören, kapatan ve erteleyen roller.
// Takip uçları, takip sayfası ve toplantıdan doğan irtibat görevinin sorumlusu
// bu listeden okur; takibi kapatmak müşterinin kaydına görüşme satırı yazar.
export const TAKIP_ROLLERI: string[] = [ROLES.ADMIN, ROLES.OPERASYON, ROLES.PAZARLAMA];

// Admin-only operations
export const ADMIN_ONLY: string[] = [ROLES.ADMIN];

// View-only roles (no create/edit)
export const VIEW_ROLES: string[] = [ROLES.GORUNTULEME, ROLES.MUHASEBE];

// Roles with production/technical view access (read-only, üretim sayfaları)
export const PRODUCTION_VIEW_ROLES: string[] = [ROLES.GORUNTULEME, ROLES.TEKNIK];

// Roles with accounting access
export const ACCOUNTING_ROLES: string[] = [ROLES.ADMIN, ROLES.MUHASEBE];

// All authenticated users
export const ALL_ROLES = Object.values(ROLES);

// Roles that can access order/product pages (excludes goruntuleme)
export const NON_VIEW_ROLES: string[] = [ROLES.ADMIN, ROLES.OPERASYON, ROLES.MUHASEBE, ROLES.PAZARLAMA];
